import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CustomerLeafWiseCollectionNewReport } from './Pages';

export const CustomerLeafWiseCollectionNewReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CustomerLeafWiseCollectionNewReport} />
    </Fragment>
)